module.exports = __webpack_public_path__ + "static/media/Illustration_Upload_Pdf.a5638e5e.svg";